import * as React from 'react';
import { useSelector } from 'react-redux';

import { Comment, CommentPart } from '../../../components/Comment';
import { getAnswerById } from '../../../selectors/answers';
import { getIsQuestionTab } from '../../../selectors/tabs';
import { EType } from '../../../types/users';

interface ICommentContainerProps {
  answerId: string;
}

export function CommentContainer({ answerId }: ICommentContainerProps) {
  const {
    comment,
    user: { type },
  } = useSelector(getAnswerById(answerId));
  const isQuestionTab = useSelector(getIsQuestionTab);
  const isBuilder = type === EType.Builder;

  return (
    <Comment title={comment.type} isQuestion={isQuestionTab} isBuilder={isBuilder}>
      <CommentPart message={comment.text} />
    </Comment>
  );
}
